// ProductCard.js
import React, {useState, useEffect} from "react";
import {useSelector} from 'react-redux';
import LazyLoad from 'react-lazyload';
import Button from "react-bootstrap/Button";
import Spinner from 'react-bootstrap/Spinner';
import {
	ProductCardWrapper,
	ProductImageWrapper,
	ProductInfo,
	DiscountPercent,
	ProductPriceWrapper,
	ProductPrice,
	PromoPrice,
	BrandLogoWrapper,
	ProductButtons,
	FavoriteContainer
} from "../../ProductCard/ProductCard.style";
import {useCart} from "../../../contexts/cart/use-cart";
import {useFavorites} from "../../../contexts/favorites/use-favorites";
import {AuthContext} from "../../../contexts/auth/auth.context";
import {QuantityModifier} from "../../QuantityModifier/QuantityModifier";
import {cartAnimation} from "../../../helper/cart-animation";
import Loader from "../../Loader/Loader";
import {compDate} from "../../../constants/Constant";
import moment from 'moment';
import itemToCartService from '../../../services/itemToCartService';
import SimpleMessageDialog from "../../SimpleMessageDialog/SimpleMessageDialog";
import delishopExpressIcon from '../../../assets/icons/delixpress_logo2.svg';
import delishopIcon from '../../../assets/icons/delishop_logo2.svg';
import t from '../../../i18n/translate';
import {CartBuy} from "../../AllSvgIcon";
import FlagIconFactory from 'react-flag-icon-css';
import {Favorite, FavoriteBorder} from "@material-ui/icons";
import ProductIcon from '../../../assets/images/delishop-favicons.png';
import {
	logAddToCart,
	logAddToWishlist,
	logRemoveFromCart,
	logRemoveFromWishlist
} from "../../../services/googleAnalytics";

const FlagIcon = FlagIconFactory(React, {useCssModules: false});
const outOfStockOverlay = {
	width: '100%',
	height: '100%',
	position: 'absolute',
	top: 0,
	left: 0,
	backgroundColor: 'rgb(247 247 247 / 60%)',
	zIndex: 1
};

const ProductCard = ({
	                     title,
	                     image,
	                     weight,
	                     outOfStock,
	                     price,
	                     salePrice,
	                     discountInPercent,
	                     data,
	                     onClick,
	                     onCartClick,
	                     promo,
	                     promoPrice,
	                     promoStartDate,
	                     promoEndDate,
	                     brandId,
	                     brand,
	                     loading,
	                     page,
	                     promoProduct = false,
	                     productCode,
	                     description,
	                     isSameDay,
	                     shopOpen,
	                     sameDayDelivery,
	                     availableTomorrow,
	                     deviceType,
	                     isFavorite
                     }) => {
	const {getItem, isInCart, resetCart, fetchOrderItems} = useCart();
	const {addItemToFavorites, removeItemFromFavorites, isInFavorites, favAddLoading, favRemoveLoading} = useFavorites();
	const [loaded, setLoaded] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [showError, setShowError] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [showHeaderDialog, setShowHeaderDialog] = useState(false);
	const [isConfirmButton, setIsConfirmButton] = useState(false);
	const [confirmLabel, setConfirmLabel] = useState('OK');
	const [closeLabel, setCloseLabel] = useState('CLOSE');
	const [dialogHeaderLabel, setDialogHeaderLabel] = useState('Error');
	const [dialogLoading, setDialogLoading] = useState(false);
	const [errorLog, setErrorLog] = useState(null);
	const [simpleDialogBackdrop, setSimpleDialogBackdrop] = useState(true);
	const [isItemFavorite, setIsItemFavorite] = useState(isFavorite == 1)
	const dayNumber = moment().isoWeekday();
	const cartType = useSelector(state => state.cartReducer.cartType);

	useEffect(() => {
		setLoaded(false);
	}, [window.location.pathname]);

	const addDefaultSrc = (e) => {
		e.target.src = cartType === 'express' ? delishopExpressIcon : delishopIcon;
	};


	const handleAddClick = async (e) => {
		e.stopPropagation();
		if (!localStorage.getItem("user") || !localStorage.getItem("token")) {
			if (onCartClick) {
				onCartClick();
			} else {
				const joinBtn = document.getElementById("joinBTn");
				if (joinBtn) joinBtn.click();
			}
			window.trigger = "add to cart";
			return;
		}

		setIsLoading(true);
		const quantity = isInCart(data.item_id) ? getItem(data.item_id).quantity + 1 : 1;
		if (quantity === 1) cartAnimation(e);

		const resp = await itemToCartService.addItem(data.item_id, cartType, quantity);
		if (resp.success) {
			logAddToCart(resp.data);
			fetchOrderItems(cartType);
		} else {
			handleCartError(resp);
		}
		setIsLoading(false);
	};

	const handleRemoveClick = async (e) => {
		e.stopPropagation();
		if (!localStorage.getItem("user")) {
			if (onCartClick) {
				onCartClick();
			} else {
				const joinBtn = document.getElementById("joinBTn");
				if (joinBtn) joinBtn.click();
			}
			window.trigger = "add to cart";
			return;
		}

		setIsLoading(true);
		const current = getItem(data.item_id);
		const resp = current.quantity === 1
			? await itemToCartService.removeItemFromCart(current, cartType)
			: await itemToCartService.addItem(data.item_id, cartType, current.quantity - 1);

		if (resp.success) {
			fetchOrderItems(cartType);
			logRemoveFromCart(resp.data || data, current.quantity === 1 ? 1 : 0);
		} else {
			setErrorMessage(resp.message);
			setShowError(true);
		}
		setIsLoading(false);
	};

	const handleInputUpdateQuantity = async (quantity) => {
		if (quantity < 1) return;
		setIsLoading(true);
		const resp = await itemToCartService.addItem(data.item_id, cartType, quantity);
		if (resp.success) {
			fetchOrderItems(cartType);
		} else {
			handleCartError(resp);
		}
		setIsLoading(false);
	};

	const handleCartError = (resp) => {
		if (resp.error === "multiSupplier") {
			setIsConfirmButton(true);
			setConfirmLabel(t('shop_add_item_to_cart_different_shop_error_remove'));
			setCloseLabel(t('shop_add_item_to_cart_different_shop_error_cancel'));
			setDialogHeaderLabel(t('shop_add_item_to_cart_different_shop_error_title'));
			setShowHeaderDialog(true);
			setErrorLog({error: true, error_type: 'multiSupplier'});
		} else if (resp.data?.type === "paymentInProgress") {
			setIsConfirmButton(true);
			setConfirmLabel(t('shop_popup_continue_payment_button'));
			setCloseLabel(t('shop_popup_cancel_payment_button'));
			setDialogHeaderLabel(t('shop_popup_payment_locked_label'));
			setShowHeaderDialog(true);
			setErrorLog({error: true, error_type: 'paymentInProgress'});
			setSimpleDialogBackdrop('static');
		}
		setErrorMessage(resp.message);
		setShowError(true);
	};

	const handleOverWriteCart = async () => {
		setDialogLoading(true);
		await resetCart();
		setTimeout(async () => {
			const resp = await itemToCartService.addItem(data.item_id, cartType);
			if (resp.success) fetchOrderItems(cartType);
			else setErrorMessage(resp.message);
			setShowError(false);
			setDialogLoading(false);
		}, 250);
	};

	const onConfirm = () => {
		if (errorLog?.error_type === 'multiSupplier') handleOverWriteCart();
		else if (errorLog?.error_type === 'paymentInProgress') window.location.href = '/checkout';
	};

	const closeSimpleDialog = () => setShowError(false);

	const handleFavorite = (e, action) => {
		e.stopPropagation();
		if (!localStorage.getItem("user") || !localStorage.getItem("token")) {
			if (onCartClick) {
				onCartClick();
			} else {
				const joinBtn = document.getElementById("joinBTn");
				if (joinBtn) joinBtn.click();
			}
			window.trigger = "add to favorites";
			return;
		}
		const query = {type: cartType === "express" ? 1 : 0, item_id: data.item_id};
		if (action === "remove") {
			if (favRemoveLoading[data.item_id]) return;
			removeItemFromFavorites(query);
			logRemoveFromWishlist(data);
			setIsItemFavorite(0)
		} else {
			if (favAddLoading[data.item_id]) return;
			addItemToFavorites(query);
			setIsItemFavorite(1)
			logAddToWishlist(data);
		}
	};

	return (
		<>
			<ProductCardWrapper itemScope itemType="http://schema.org/Product" onClick={onClick} className="product-card">
				<ProductImageWrapper className={cartType}>
					{/*brand logo*/}
					{brand && brand.image && (
						<BrandLogoWrapper>
							<LazyLoad height={140}>
								<img
									src={brand?.image}
									className={promoProduct ? "brand-promo" : "brand-image"}
									alt={brand?.name}
									onError={addDefaultSrc}
								/>
							</LazyLoad>
						</BrandLogoWrapper>
					)}

					{/*ribbon*/}
					<div className="ribbon">
						{!loaded && <Loader className="loaderStyle" color={cartType === 'express' ? "#f01266" : "#9cc54b"}/>}
						<div className="product-image-wrapper">
							<meta itemProp="image" content={image || ProductIcon}/>
							<meta itemProp="description" content={description || ''}/>
							<LazyLoad height={140}>
								<img
									src={loading && page === 1 ? require('../../../image/white.png') : (image || ProductIcon)}
									className={promoProduct ? "promo-image product-image" : "product-image"}
									alt={title}
									onError={addDefaultSrc}
									onLoad={() => setLoaded(true)}
								/>
							</LazyLoad>
						</div>

						{cartType !== 'express' ? (
							isSameDay && !outOfStock ? <span className="ribbon3">{t('shop_item_get_same_day')}</span> :
								!outOfStock && availableTomorrow ?
									<span className="ribbon3 full-width">{t('shop_item_get_tomorrow')}</span> : null
						) : (
							isSameDay && shopOpen && !outOfStock ?
								<span className="ribbon3">{t('shop_item_get_same_day')}</span> : null
						)}

						{promo === 1 && !outOfStock && (
							<span className={`ribbon4`}>{t('shop_item_promo_label')}</span>
						)}
					</div>
				</ProductImageWrapper>

				{loading && page === 1 ? (
					<div style={{textAlign: "center", paddingBottom: "20px"}}>{t('toast_downloading')}</div>
				) : (
					<ProductInfo>
						{outOfStock && <div style={outOfStockOverlay}/>}

						<div className="d-flex justify-content-between" style={{width: '100%'}}>
							<h3 itemProp="name" className={promoProduct ? "promo-title product-title" : "product-title"}
							    style={{paddingTop: '3px'}}>
								{title}
								{brand && <> - <span itemProp="brand">{brand.name}</span></>}
							</h3>

							<FavoriteContainer className={cartType}>
								{isItemFavorite && (!favAddLoading[data.item_id] || !favRemoveLoading[data.item_id]) ? (
									<Button variant="light" size="sm" className={`btn-favorite ${cartType}`}
									        onClick={(e) => handleFavorite(e, "remove")}>
										{favRemoveLoading[data.item_id] ? <Spinner animation="border" size="sm"/> :
											<Favorite fontSize="small"/>}
									</Button>
								) : (
									<Button variant="light" size="sm" className={`btn-favorite ${cartType}`}
									        onClick={(e) => handleFavorite(e, "add")}>
										{favAddLoading[data.item_id] ? <Spinner animation="border" size="sm"/> :
											<FavoriteBorder fontSize="small"/>}
									</Button>
								)}
							</FavoriteContainer>
						</div>

						<div className={`product-meta ${cartType}`}>
							<meta itemProp="url" content={`https://delishop.asia${window.location.pathname}`}/>
							<meta itemProp="sku" content={productCode}/>

							<div className="product-body"
							     style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end", width: "100%"}}>
								<div className="product-country-and-weight">
									<div className="product-country">
										{cartType === "express" && data.country ? (
											<FlagIcon code={data.country.code.toLowerCase()} size="lg"/>
										) : data.countries?.[0] ? (
											<FlagIcon code={data.countries[0].code.toLowerCase()} size="lg"/>
										) : null}
									</div>
									{weight &&
										<p itemProp="weight" className={promoProduct ? "promo-weight product-weight" : "product-weight"}
										   style={{fontSize: "1rem"}}>{weight}</p>}
								</div>
							</div>

							<div className="product-footer" style={{width: "100%"}}>
								<ProductPriceWrapper itemProp="offers" itemScope itemType="https://schema.org/Offer"
								                     className={promoProduct && "promo-price"}>
									<meta itemProp="availability"
									      content={outOfStock ? "https://schema.org/OutOfStock" : "https://schema.org/InStock"}/>
									{salePrice > 0 && (
										<ProductPrice
											className={promo === 1 ? `strike-through ${cartType}` : ""}>
											${parseFloat(salePrice).toFixed(2)}
										</ProductPrice>
									)}
									{promo === 1 && (
										<PromoPrice className={promoProduct ? "promo-price" : ""}>
											${parseFloat(promoPrice).toFixed(2)}
										</PromoPrice>
									)}
								</ProductPriceWrapper>

								{cartType !== "express" ? (
									outOfStock ? (
										<div style={{color: "red", textAlign: 'end'}}>{t('shop_item_out_of_stock')}</div>
									) : (
										<ProductButtons>
											{!isInCart(data.item_id) ? (
												<Button className="btn btn-outline-success" onClick={handleAddClick} disabled={isLoading}>
													{isLoading ? <Spinner animation="border" size="sm" style={{color: "#9cc54b"}}/> :
														<span className="cart-icon"><CartBuy/></span>}
													<span className="cart-buy">Buy</span>
												</Button>
											) : (
												<div className={`${promo === 1 && "promo-price"}`} onClick={e => e.stopPropagation()}>
													<QuantityModifier
														className={`pr${data.item_id} ${cartType} ${promoProduct && "promo-price"}`}
														value={getItem(data.item_id).quantity}
														onDecrement={handleRemoveClick}
														onIncrement={handleAddClick}
														onUpdate={handleInputUpdateQuantity}
														promoProduct={promoProduct}
														isLoading={isLoading}
													/>
												</div>
											)}
										</ProductButtons>
									)
								) : data.is_shop_open ? (
									outOfStock ? (
										<div style={{color: "red"}}>{t('shop_item_out_of_stock')}</div>
									) : (
										<ProductButtons>
											{!isInCart(data.item_id) ? (
												<Button className="btn-outline-express" onClick={handleAddClick} disabled={isLoading}>
													{isLoading ? <Spinner animation="border" size="sm" style={{color: "#f01266"}}/> :
														<span className="cart-icon express"><CartBuy/></span>}
													<span className="cart-buy">Buy</span>
												</Button>
											) : (
												<div onClick={e => e.stopPropagation()}>
													<QuantityModifier
														className={`pr${data.item_id} ${cartType}`}
														value={getItem(data.item_id).quantity}
														onDecrement={handleRemoveClick}
														onIncrement={handleAddClick}
														onUpdate={handleInputUpdateQuantity}
														promoProduct={promoProduct}
														isLoading={isLoading}
													/>
												</div>
											)}
										</ProductButtons>
									)
								) : outOfStock ? (
									<div style={{color: "red"}}>{t('shop_item_out_of_stock')}</div>
								) : null}
							</div>
						</div>
					</ProductInfo>
				)}
			</ProductCardWrapper>

			<SimpleMessageDialog
				show={showError}
				message={errorMessage}
				showHeader={showHeaderDialog}
				closeLabel={closeLabel}
				confirmLabel={confirmLabel}
				headerLabel={dialogHeaderLabel}
				isConfirmButton={isConfirmButton}
				onClose={closeSimpleDialog}
				onConfirm={onConfirm}
				backdrop={simpleDialogBackdrop}
				loading={dialogLoading}
				cartType={cartType}
			/>
		</>
	);
};

export default ProductCard;